<template>
    <div  class="w-full h-[150%] fixed top-0 left-0 bg-[#00000063] z-30 backdrop-blur-[2px]"></div>
        <div class="flex fixed justify-center top-[20%] bottom-[20%]  left-[3%] right-[3%] xl:left-[10%] xl:right-[10%] items-center z-40">
            <div class="flex flex-col justify-center  z-40 bg-white w-[700px] md:w-[800px] lg:w-[1000px] text-lg rounded-lg relative overflow-hidden">
                <div class="pafcpic_header bg-[#016B00] px-4 py-3 lg:py-3 lg:px-6">
                    <div class="flex justify-between">
                        <div>
                            <p class="text-[#ffffff] font-bold uppercase text-[12px] md:text-[15px] lg:text-[18px]">OFFICIAL BUSINESS REQUEST</p>
                        </div>
                        <div>
                            <p class="text-[#ffffff] font-bold uppercase text-[12px] md:text-[15px] lg:text-[18px] hover:text-[#c9c9c9d2]" @click="$emit('close')">X</p>
                        </div>
                    </div>
                </div>
                <div class="pafcpic_body py-3 px-5 lg:py-6 lg:px-10 overflow-y-auto">
                    <p class="text-[#016B00] text-xs lg:text-sm">Reference No.</p>
                    <p class="text-[#016B00] font-semibold text-lg md:text-xl lg:text-2xl">{{ data.ref_no }}</p>
                    <div class="grid grid-cols-2 lg:grid-cols-2 gap-2 lg:gap-5 mt-4 max-sm:text-sm">
                        <div>
                            <p class="text-xs lg:text-sm text-[#7a7a7a]">Employee Name</p>
                            <p class="font-semibold text-[#686868] text-[0.95rem] lg:text-lg leading-tight">{{ data.employee_name }}</p>
                        </div>
                        <div>
                            <p class="text-xs lg:text-sm text-[#7a7a7a]">Date Submitted</p>
                            <p class="font-semibold text-[#686868] text-[0.95rem] lg:text-lg leading-tight">{{ formatDate(data.date_applied)}}</p>
                        </div>
                        <div v-for="(data, index) in date" :key="index" class=" border-dotted border-[#CBCBCB] border-[2px] rounded-md py-2 px-2 flex  bg-[#EAEAEA] justify-between">
                            <div class="flex gap-3">
                                <div class="flex items-center justify-center">
                                    <div class="rounded-full bg-[#D9D9D9] w-7 h-7 flex items-center text-xs justify-center font-bold text-[#016B00]">
                                        {{ index + 1 }}
                                    </div>
                                </div>
                                <div>
                                    <p class="text-xs text-[#949494]">Date of Official Business</p>
                                    <p class="text-[#016B00] text-sm font-semibold">{{ data.fromdate }} - {{ data.todate}}</p>
                                </div>
                            </div>
                        </div>
                        <!-- <div>
                            <p class="text-xs lg:text-sm text-[#7a7a7a]">Covered Date</p>
                            <p class="font-semibold text-[#686868] text-[0.95rem] lg:text-lg leading-tight">{{ data.covered_date}}</p>
                        </div> -->
                        <!-- <div>
                            <p class="text-xs lg:text-sm text-[#7a7a7a]">Category</p>
                            <p  v-for="(item, index) in categoryList(data.category)" :key="index" class="font-semibold text-[#686868] text-[0.95rem] lg:text-lg  leading-tight">{{ item }}</p>
                        </div> -->
                        <div>
                            <p class="text-xs lg:text-sm text-[#7a7a7a] leading-tight mb-1 lg:mb-0">Location</p>
                            <p class="font-semibold text-[#686868] text-[0.95rem] lg:text-lg leading-tight">{{ data.location}}</p>
                        </div>
                        <div>
                            <p class="text-xs lg:text-sm text-[#7a7a7a] leading-tight mb-1 lg:mb-0">Purpose</p>
                            <p class="font-semibold text-[#686868] text-[0.95rem] lg:text-lg leading-tight">{{ data.purpose}}</p>
                        </div>
                    </div>
                </div>
                <div class="border-t border-dashed border-[#a7a7a7] p-4 mx-5 "></div>
                <div class="px-5 lg:px-10 max-h-[150px] overflow-auto">
                    <div class="flex gap-5">
                        <div class=" w-full flex flex-col gap-2 text-sm max-sm:text-xs">
                            <label class=" text-[#6A6A6A] font-semibold">Approved by:</label>
                            <div v-if="approval == null">
                                <p class=" text-[#a5a5a5]">NO SIGNATORY FOUND</p>
                            </div>
                            <div v-else v-for="(approval,index) in approval" :key="index" class="">
                                <div v-if="approval != null">
                                    <div class="flex relative w-auto">
                                        <p class=" font-semibold " :class="{'text-[#016B00]': approval.status == 'A','text-[#792424]': approval.status == 'D','text-[#8d8d8d]': !approval.status}">{{approval.employee_name}}</p>
                                    </div>
                                    <label class=" text-[#6A6A6A]">{{ approval.position_name }}</label>
                                    <div v-if="approval.status == 'D'">
                                        <label v-if="approval.remarks != null" class="text-xs font-semibold text-[#6A6A6A]">Remarks:</label>
                                        <p class=" font-semibold text-[#792424]"> {{approval.remarks}}</p>
                                    </div>
                                </div>
                          </div>
                        </div>
                    </div>
                </div>
            <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 font-medium">
                <button class="text-sm text-white bg-[#016B00] py-2 px-7 rounded-sm hover:bg-[#026b00bb] w-[150px]" v-if="apv" @click="$emit('approveRequest', data.ref_no)" >APPROVE</button>
                <button class="text-sm text-white bg-[#016B00] py-2 px-7 rounded-sm hover:bg-[#026b00bb] w-[150px]" v-if="noted && data.status === 'APPROVED'" @click="$emit('notedRequest', data.ref_no)" >NOTED</button>
                <button class="text-sm text-[#ffffff] bg-[#9b2b2b] py-2 px-7 rounded-sm  hover:bg-[#9b2b2bb0] w-[150px]" v-if="apv" @click="$emit('disapproveRequest', data.ref_no)">DISAPPROVE</button>
                <button class="text-sm text-[#ffffff] bg-[#860000] py-2 px-7 rounded-sm hover:bg-[#5a0101] w-[200px]" v-if="data.status!='CANCELLED' && data.status!='DISAPPROVED' && sign && cancel" @click="$emit('cancelrequest', data.ref_no)">CANCEL REQUEST</button>
            </div>
        </div>
    </div>
</template>

<script>

import { defineComponent } from "vue";
import Obusiness from "@/services/officialbusiness";

export default defineComponent({
    components: {
       
    },
    data() {
        return {
            ref_no:null,
            signatory: null,
            recommendation:'',
            approval:'',
            sign: false,
            date: null,
        }
    },
    props: {
        data: {
            type: Object,
            default: null,
        },
        apv:{
            type : Boolean,
            default: false,
        },
        cancel:{
            type : Boolean,
            default: false,
        },
        noted:{
            type : Boolean,
            default: false,
        },
        
    },
    mounted(){
        this.ref_no = this.data.ref_no
        this.getObData()
    },
    methods:{
        formatDate(date) {
            return new Date(date).toLocaleString('en-US', {
                month: '2-digit',
                day: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            });
        },
        async getObData(){
            let that = this
            await Obusiness.getobData(this.ref_no).then(function(response){
                that.signatory = response.data.data.signatory
                that.date      = response.data.data.date
            })
            that.getObusinessSignatory()
        },
        getObusinessSignatory(){
            if(this.signatory!=null ){
                this.approval = this.signatory.filter(signatory=>signatory.rank == 'A')
                this.sign   = this.signatory.filter(e=>e.date != null) ? true : false
            }
        },
    }
})

</script>